export const SEARCH_FIELD_DEFAULTS = {
  placeholderMessageId: 'chatPage.searchList.placeholder',
  testId: 'search-field-input',
} as const;
